import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinancialStatements = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#d87de7",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "FinancialStatements",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 16660",
					d: "M2.5 0.5H10.3789C10.644 0.50006 10.8985 0.605486 11.0859 0.792969L14.207 3.91406C14.3945 4.10155 14.4999 4.35596 14.5 4.62109V14.5C14.5 15.0523 14.0523 15.5 13.5 15.5H2.5C1.94772 15.5 1.5 15.0523 1.5 14.5V1.5C1.5 0.947715 1.94772 0.5 2.5 0.5Z",
					fill: "currentColor",
					fillOpacity: .25,
					stroke: "currentColor"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Rectangle 16669",
					children: [/* @__PURE__ */ _jsx("mask", {
						id: "path-2-inside-1_3025_103",
						fill: "white",
						children: /* @__PURE__ */ _jsx("rect", {
							x: 3.42871,
							y: 5.901,
							width: 9.06543,
							height: 7.67017,
							rx: .5
						})
					}), /* @__PURE__ */ _jsx("rect", {
						x: 3.42871,
						y: 5.901,
						width: 9.06543,
						height: 7.67017,
						rx: .5,
						stroke: "currentColor",
						strokeWidth: 2,
						mask: "url(#path-2-inside-1_3025_103)"
					})]
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16670",
					x: 5.97729,
					y: 6.62677,
					width: 1.25,
					height: 6.20197,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16671",
					x: 11.7021,
					y: 8.48608,
					width: 1.25,
					height: 7.95685,
					transform: "rotate(90 11.7021 8.48608)",
					fill: "currentColor"
				})
			]
		})
	})
});
export default SvgFinancialStatements;
